import { useSelector } from 'react-redux';
import { PartnerLayoutWithSidebar } from '../../../common/components';
import { getSelectedOrg } from '../../../common/store';
import UpdateBankAccount from '../../common/bank-accounts/UpdateBankAccount';

const PartnerUpdateBankAccount = () => {
    const selectedOrg = useSelector(getSelectedOrg);
    const orgId = selectedOrg?.id;

    return (
        <PartnerLayoutWithSidebar>
            <UpdateBankAccount orgId={orgId} />
        </PartnerLayoutWithSidebar>
    );
};
export default PartnerUpdateBankAccount;
